export * from "/codebuild/output/src3560772302/src/git-codecommit.eu-west-2.amazonaws.com/v1/repos/vl-app/vl-common/wrapped-antd/index.ts"